import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import AddIcon from '@material-ui/icons/Add'
import Divider from '@material-ui/core/Divider'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import { showSnackBar } from '../../store/AlertMessages/actionCreator'
import ListingLoader from '../Common/skeletonLoaders/listingLoader'
import { fetchExternalAssignments } from '../../store/Assignments/actionCreator'
import AddAssignmentForm from '../Assignment/addAssignment'
import AssingnmentsListing from './assignmentListing'

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper
  },
  button: {
    flexGrow: 1,
    marginRight: '38px',
    backgroundColor: '#3098FF',
    color: '#FFFFFF',
    '&:hover': {
      backgroundColor: '#3098FF',
    },
  },
}))

function MyAssignments(props) {
  const classes = useStyles()
  const rowsPerPage = 10
  const offset = 0
  const [page, setPage] = useState(0);
  const [inProgress, setInProgress] = useState(false)
  const [addAssignmentMode, setAddAssignmentMode] = useState(false)
  const [assignmentsData, setAssignmentsData] = useState([])
  const [totalCount, setTotalCount] = useState(0)

  const successFetchCB = res => {
    setInProgress(false)
    setAssignmentsData(res && res.data && res.data)
    setTotalCount(res && res.count)
  }
  const failureFetchCB = err => {
    setInProgress(false)
    setAssignmentsData([])
    setTotalCount(0)
  }

  const listAssignments = () => {
    setInProgress(true)
    const payload = {
      offset: offset,
      number: 10
    }
    fetchExternalAssignments(payload, successFetchCB, failureFetchCB)
  }

  useEffect(()=>{
    listAssignments()
    document.getElementById('mainH1Tag') && document.getElementById('mainH1Tag').focus()
  },[])

  const listLoader = () => {
    let children = []
    for (let i = 0; i < 4; i++) {
     children.push(<ListItem key={i} alignItems="flex-start"><ListingLoader/></ListItem>)
    }
    return (
      <List>
        {children}
      </List>
    )
  }

  const triggerAddAssignment = () => {
    setAddAssignmentMode(true)
  }

  const closeAddForm = () => {
    setAddAssignmentMode(false)
  }

  const onPagination = (pageNum) => {
    setInProgress(true)
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    setPage(pageNum)
    let offset = pageNum * rowsPerPage
    let number = 10
    const payload = {
      offset: offset,
      number: number
    }
    fetchExternalAssignments(payload, successFetchCB, failureFetchCB)
  }

  return(
    <div className={classes.root}>
      {inProgress ? listLoader() : (
        <React.Fragment>
          { addAssignmentMode ? (
            <AddAssignmentForm match={props.match} history={props.history} cancelAddAssignment={closeAddForm} listAllAssignment={listAssignments} from="externalType"/>
          ) : (
            <React.Fragment>
              { assignmentsData && assignmentsData.length ? (
                <div style={{ textAlign: 'right', marginRight: '21px' }}>
                  <Button
                    variant="contained"
                    className={classes.button}
                    startIcon={<AddIcon />}
                    onClick={triggerAddAssignment}
                  >
                    <Divider orientation="vertical" flexItem style={{ marginRight: '10px', backgroundColor: '#bdbdbd'}} aria-hidden="true"/>
                      Assignment
                  </Button>
                </div>
              ) : null }
            </React.Fragment>
          )}
          { inProgress ? listLoader() : (
            <React.Fragment>
              { assignmentsData && !addAssignmentMode ? (
                <AssingnmentsListing 
                  assignmentsData={assignmentsData}
                  history={props.history}
                  match={props.match}
                  listAllAssignment={listAssignments}
                  triggerAddAssignment={triggerAddAssignment}
                  page={page}
                  rowsPerPage={rowsPerPage}
                  onPaginationHit={onPagination}
                  totalCount={totalCount}
                />
              ) : null }
            </React.Fragment>
          )}
        </React.Fragment>
      ) }
    </div>
  )
}
const mapStateToProps = state => {
  return {}
}
export default connect(
  mapStateToProps, { showSnackBar }
)(MyAssignments);